import { z } from 'zod/v3';

export const OrganizationSsoProtocolSchema = z.literal('SAML');
export const OrganizationSsoStatusSchema = z.enum([
  'SETUP',
  'ACTIVE',
  'DISABLED',
]);

export const OrganizationSsoConfigDTOSchema = z.object({
  providerId: z.string(),
  protocol: OrganizationSsoProtocolSchema,
  status: OrganizationSsoStatusSchema,
  displayName: z.string(),
  domain: z.string(),
  connectionVerified: z.boolean(),
  issuer: z.string().url().nullable(),
  samlMetadata: z.string().nullable(),
  samlEmailAttribute: z.string().nullable(),
  samlNameAttribute: z.string().nullable(),
  callbackUrl: z.string().url(),
  spMetadataUrl: z.string().url().nullable(),
  lastTestedAt: z.date().nullable(),
  updatedAt: z.date(),
}).strict();

export type OrganizationSsoProtocol = z.infer<
  typeof OrganizationSsoProtocolSchema
>;
export type OrganizationSsoStatus = z.infer<
  typeof OrganizationSsoStatusSchema
>;
export type OrganizationSsoConfigDTO = z.infer<
  typeof OrganizationSsoConfigDTOSchema
>;
